import type { EventSurface, RenderableSuggestion } from "@/domain/suggestions";
import { computeItemTotal } from "@/lib/pricing";
import type { CartItem } from "@/types";
import { v4 as uuid } from "uuid";

/**
 * Builds the one-tap `CartItem` for a suggestion whose offer has NO required
 * option group — mirrors `ItemQuantityButton`'s plain-offer branch in
 * `ItemOfferCard.tsx`, plus `addedVia` for suggestion attribution.
 */
export function buildSuggestionCartItem(suggestion: RenderableSuggestion, surface: EventSurface): CartItem {
  const unitPrice = computeItemTotal(suggestion.itemOffer, [], {});
  return {
    id: uuid(),
    item: suggestion.item,
    itemOffer: suggestion.itemOffer,
    itemOptions: {},
    optionGroups: [],
    optionQuantities: {},
    quantity: 1,
    itemTotalPrice: unitPrice,
    unitPrice,
    specialInstructions: "",
    addedVia: surface,
    addedViaArm: suggestion.arm,
    ...(suggestion.anchorItemId ? { addedViaAnchorItemId: suggestion.anchorItemId } : {}),
  };
}
